export enum OrganisationRole {
  DEFAULT = 'DEFAULT',
  MANAGER = 'MANAGER',
  OWNER = 'OWNER',
}
